import { useState } from "react";

// ── SEO SCHEMA ──
const schema = {
  "@context": "https://schema.org",
  "@type": "ItemList",
  "name": "Best Event Planners in Raipur Chhattisgarh",
  "description": "Top verified event planners near you in Raipur, CG",
  "url": "https://decorhub-ruddy.vercel.app/event-planners",
  "itemListElement": [
    { "@type": "ListItem", "position": 1, "name": "Wedding Planners Raipur" },
    { "@type": "ListItem", "position": 2, "name": "Birthday Event Planners Raipur" },
    { "@type": "ListItem", "position": 3, "name": "Corporate Event Planners Raipur CG" },
  ],
};

const categories = [
  { icon: "💍", label: "Wedding Planner", count: "50+", color: "#e91e8c", keyword: "wedding" },
  { icon: "🎂", label: "Birthday Events", count: "80+", color: "#f59e0b", keyword: "birthday" },
  { icon: "🏢", label: "Corporate Events", count: "30+", color: "#00d4aa", keyword: "corporate" },
  { icon: "🎊", label: "Anniversary", count: "40+", color: "#7c3aed", keyword: "anniversary" },
  { icon: "👶", label: "Baby Shower", count: "25+", color: "#ec4899", keyword: "babyshower" },
  { icon: "🏠", label: "Griha Pravesh", count: "35+", color: "#f97316", keyword: "grihapravesh" },
];

const cities = [
  "Raipur", "Bilaspur", "Durg", "Bhilai", "Korba", "Jagdalpur", "Rajnandgaon", "Ambikapur"
];

const whyUs = [
  { icon: "✅", title: "100% Verified Planners", desc: "Every planner on DecorHub is manually verified for quality, portfolio, and reliability.", color: "#00d4aa" },
  { icon: "📍", title: "Local to Raipur, CG", desc: "Planners who know Chhattisgarh — local vendors, local venues, local expertise.", color: "#e91e8c" },
  { icon: "💰", title: "Best Price Guarantee", desc: "Compare multiple planners and choose the best one within your budget.", color: "#f59e0b" },
  { icon: "⚡", title: "Book in 5 Minutes", desc: "Simple booking process — no phone tag, no back and forth. Book instantly online.", color: "#7c3aed" },
  { icon: "🌟", title: "Real Reviews Only", desc: "Only genuine customers who booked through us can leave reviews. No fake ratings.", color: "#ec4899" },
  { icon: "📞", title: "24/7 Support", desc: "Our team is always here to help you before, during, and after your event.", color: "#f97316" },
];

export default function EventPlannersPage() {
  const [activeCity, setActiveCity] = useState("Raipur");
  const [activeCategory, setActiveCategory] = useState(null);

  return (
    <div style={S.page}>
      <style>{CSS}</style>

      {/* ── HERO ── */}
      <section style={S.hero}>
        <div style={S.heroBg1} />
        <div style={S.heroBg2} />
        <div style={S.heroBg3} />
        <div style={S.heroInner}>

          {/* Breadcrumb */}
          <nav style={S.breadcrumb}>
            <a href="/" style={S.breadcrumbLink}>Home</a>
            <span style={S.breadcrumbSep}>›</span>
            <span style={S.breadcrumbCurrent}>Event Planners</span>
          </nav>

          <div className="fup" style={{ "--d": "0s" }}>
            <span style={S.badge}><span style={S.bdot} />Event Planners · Raipur, CG</span>
          </div>

          <h1 className="fup" style={{ "--d": "0.1s", ...S.h1 }}>
            Best Event Planners
            <br />
            <span style={S.h1accent}>Near Me</span> in Raipur,
            <br />
            Chhattisgarh
          </h1>

          <h2 className="fup" style={{ "--d": "0.2s", ...S.h2 }}>
            Find Top Verified Event Planners in Raipur CG — Compare Prices & Book Instantly
          </h2>

          <p className="fup" style={{ "--d": "0.3s", ...S.heroPara }}>
            Looking for an <strong style={{ color: "#fff" }}>event planner near you in Raipur, Chhattisgarh?</strong> DecorHub connects you with the best verified event planners, wedding planners, and corporate event managers across Raipur, Bilaspur, Durg, Bhilai and all of CG. Compare profiles, read genuine reviews, and book your event planner in minutes — completely free!
          </p>

          <div className="fup" style={{ "--d": "0.4s", display: "flex", gap: "14px", flexWrap: "wrap" }}>
            <a href="/decorators?type=event_planner" style={S.btnPrimary}>Find Event Planners Near Me →</a>
            <a href="/register?type=event_planner" style={S.btnSecondary}>List Your Business Free</a>
          </div>

          <div className="fup" style={{ "--d": "0.5s", ...S.quickStats }}>
            {[["200+", "Event Planners"], ["8", "Cities in CG"], ["500+", "Events Done"], ["4.8★", "Avg Rating"]].map(([v, l]) => (
              <div key={l} style={S.qstat}>
                <span style={S.qstatNum}>{v}</span>
                <span style={S.qstatLabel}>{l}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CITY TABS ── */}
      <section style={S.citySection}>
        <div style={S.cityInner}>
          <p style={S.cityLabel}>📍 Select Your City</p>
          <div style={S.cityRow}>
            {cities.map((city) => (
              <button
                key={city}
                onClick={() => setActiveCity(city)}
                style={{ ...S.cityBtn, ...(activeCity === city ? S.cityBtnActive : {}) }}
              >
                {city}
                {activeCity === city && <span style={S.cityCheck}>✓</span>}
              </button>
            ))}
          </div>
          <p style={S.cityResult}>
            Showing event planners in <strong style={{ color: "#e91e8c" }}>{activeCity}, Chhattisgarh</strong>
          </p>
        </div>
      </section>

      {/* ── EVENT CATEGORIES ── */}
      <section style={S.section}>
        <div style={S.sectionHead}>
          <span style={S.sLabel}>Browse by Event Type</span>
          <h2 style={S.sTitle}>Find Event Planners for Every Occasion</h2>
          <p style={S.sSub}>From intimate birthday parties to grand weddings — we have the right planner for every event in {activeCity}, CG</p>
        </div>
        <div style={S.catGrid}>
          {categories.map((cat) => (
            <a
              key={cat.keyword}
              href={`/decorators?type=event_planner&category=${cat.keyword}&city=${activeCity.toLowerCase()}`}
              style={{
                ...S.catCard,
                ...(activeCategory === cat.keyword
                  ? { borderColor: cat.color, background: `${cat.color}12` }
                  : {}),
              }}
              className="cat-card"
              onClick={() => setActiveCategory(cat.keyword)}
            >
              <div style={{ ...S.catIcon, background: `${cat.color}18`, border: `1px solid ${cat.color}33` }}>{cat.icon}</div>
              <div style={S.catLabel}>{cat.label}</div>
              <div style={{ ...S.catCount, color: cat.color }}>{cat.count} planners</div>
              <div style={{ ...S.catArrow, color: cat.color }}>→</div>
            </a>
          ))}
        </div>
      </section>

      {/* ── SEO TEXT BLOCK ── */}
      <section style={S.seoBlock}>
        <div style={S.seoInner}>
          <h2 style={S.seoTitle}>Event Planners Near Me in Raipur, Chhattisgarh</h2>
          <div style={S.seoCols}>
            <div>
              <h3 style={S.seoH3}>Wedding Planners in Raipur CG</h3>
              <p style={S.seoPara}>
                Looking for the best <strong>wedding planners near you in Raipur, Chhattisgarh?</strong> DecorHub has a network of experienced wedding planners who specialize in traditional CG weddings, destination weddings, and budget-friendly wedding packages across Raipur, Bilaspur, and Durg.
              </p>

              <h3 style={{ ...S.seoH3, marginTop: "20px" }}>Birthday Event Planners in Raipur</h3>
              <p style={S.seoPara}>
                Planning a birthday party in Raipur? Find top-rated <strong>birthday event planners near you</strong> on DecorHub. From kids' theme parties to surprise adult birthdays — our planners handle everything from decoration to catering.
              </p>
            </div>
            <div>
              <h3 style={S.seoH3}>Corporate Event Planners in Raipur CG</h3>
              <p style={S.seoPara}>
                Need a <strong>corporate event planner in Raipur, Chhattisgarh?</strong> DecorHub connects you with professional corporate event managers for product launches, conferences, team outings, and company celebrations across CG.
              </p>

              <h3 style={{ ...S.seoH3, marginTop: "20px" }}>Event Planners Across Chhattisgarh</h3>
              <p style={S.seoPara}>
                DecorHub serves <strong>event planners in Raipur, Bilaspur, Durg, Bhilai, Korba, Jagdalpur, Rajnandgaon,</strong> and Ambikapur. Whether you're in a metro city or a smaller town in CG — we have the right event planner near you.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ── WHY DECORHUB ── */}
      <section style={{ ...S.section, background: "rgba(255,255,255,0.01)", borderTop: "1px solid rgba(255,255,255,0.05)" }}>
        <div style={S.sectionHead}>
          <span style={S.sLabel}>Why DecorHub</span>
          <h2 style={S.sTitle}>Why 500+ People Trust DecorHub</h2>
        </div>
        <div style={S.whyGrid}>
          {whyUs.map((w) => (
            <div key={w.title} className="why-card" style={S.whyCard}>
              <div style={{ ...S.whyIcon, background: `${w.color}15`, border: `1px solid ${w.color}30` }}>{w.icon}</div>
              <h3 style={S.whyTitle}>{w.title}</h3>
              <p style={S.whyDesc}>{w.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ── BOTTOM CTA ── */}
      <section style={S.cta}>
        <div style={S.ctaGlow} />
        <div style={{ position: "relative", zIndex: 1, textAlign: "center" }}>
          <h2 style={S.ctaTitle}>Find the Best Event Planner Near You</h2>
          <p style={S.ctaSub}>
            Browse 200+ verified event planners in {activeCity}, Chhattisgarh.<br />
            Free to use · No booking fees · Instant contact
          </p>
          <div style={{ display: "flex", gap: "14px", justifyContent: "center", flexWrap: "wrap" }}>
            <a href={`/decorators?type=event_planner&city=${activeCity.toLowerCase()}`} style={S.btnPrimary}>
              Browse Event Planners in {activeCity} →
            </a>
            <a href="/register?type=event_planner" style={S.btnSecondary}>
              Are You a Planner? Join Free
            </a>
          </div>
          {/* Hidden keyword text for SEO */}
          <p style={{ fontSize: "12px", color: "rgba(255,255,255,0.2)", marginTop: "24px", lineHeight: "2" }}>
            Event planner near me · Wedding planner Raipur · Event management Chhattisgarh ·
            Birthday planner Raipur CG · Corporate event planner Raipur · Best event planner near me ·
            Event planner Bilaspur · Event planner Durg Bhilai
          </p>
        </div>
      </section>
    </div>
  );
}

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Syne:wght@700;800&family=DM+Sans:wght@400;500;600;700&display=swap');
  * { box-sizing: border-box; margin: 0; padding: 0; }
  .fup { opacity: 0; transform: translateY(22px); animation: fup 0.65s cubic-bezier(0.4,0,0.2,1) var(--d,0s) forwards; }
  @keyframes fup { to { opacity: 1; transform: none; } }
  @keyframes pulse { 0%,100%{opacity:1;transform:scale(1)} 50%{opacity:0.4;transform:scale(0.6)} }
  .cat-card { transition: all 0.25s; text-decoration: none; }
  .cat-card:hover { transform: translateY(-4px); border-color: rgba(255,255,255,0.2) !important; }
  .why-card { transition: all 0.25s; }
  .why-card:hover { transform: translateY(-4px); border-color: rgba(233,30,140,0.3) !important; }
  a { text-decoration: none; }
  button { border: none; cursor: pointer; }
  strong { font-weight: 700; }
`;

const S = {
  page: { minHeight: "100vh", background: "#07080f", color: "#fff", fontFamily: "'DM Sans',sans-serif" },

  // HERO
  hero: { position: "relative", overflow: "hidden", padding: "100px 24px 80px", borderBottom: "1px solid rgba(255,255,255,0.06)" },
  heroBg1: { position: "absolute", width: "600px", height: "600px", borderRadius: "50%", background: "radial-gradient(circle,rgba(233,30,140,0.14),transparent 70%)", top: "-200px", right: "-150px", pointerEvents: "none" },
  heroBg2: { position: "absolute", width: "400px", height: "400px", borderRadius: "50%", background: "radial-gradient(circle,rgba(124,58,237,0.1),transparent 70%)", bottom: "-100px", left: "-100px", pointerEvents: "none" },
  heroBg3: { position: "absolute", inset: 0, background: "linear-gradient(160deg,#100020 0%,#07080f 55%)", pointerEvents: "none" },
  heroInner: { position: "relative", zIndex: 1, maxWidth: "820px" },

  breadcrumb: { display: "flex", alignItems: "center", gap: "8px", marginBottom: "24px" },
  breadcrumbLink: { fontSize: "13px", color: "rgba(255,255,255,0.35)", textDecoration: "none" },
  breadcrumbSep: { color: "rgba(255,255,255,0.2)", fontSize: "13px" },
  breadcrumbCurrent: { fontSize: "13px", color: "rgba(255,255,255,0.6)", fontWeight: "600" },

  badge: { display: "inline-flex", alignItems: "center", gap: "8px", background: "rgba(233,30,140,0.08)", border: "1px solid rgba(233,30,140,0.25)", color: "#e91e8c", padding: "7px 18px", borderRadius: "50px", fontSize: "12px", fontWeight: "700", letterSpacing: "2px", textTransform: "uppercase", marginBottom: "22px" },
  bdot: { width: "7px", height: "7px", borderRadius: "50%", background: "#e91e8c", boxShadow: "0 0 8px #e91e8c", display: "inline-block", animation: "pulse 2s infinite" },

  h1: { fontFamily: "'Syne',sans-serif", fontSize: "clamp(34px,6vw,64px)", fontWeight: "800", lineHeight: "1.1", marginBottom: "16px", color: "#fff" },
  h1accent: { background: "linear-gradient(135deg,#e91e8c,#ff6b35)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" },
  h2: { fontSize: "clamp(14px,2vw,17px)", color: "rgba(255,255,255,0.45)", fontWeight: "500", marginBottom: "20px", lineHeight: "1.6" },
  heroPara: { fontSize: "15px", color: "rgba(255,255,255,0.55)", lineHeight: "1.9", marginBottom: "32px", maxWidth: "680px" },

  btnPrimary: { display: "inline-block", background: "linear-gradient(135deg,#e91e8c,#7c3aed)", color: "#fff", padding: "14px 28px", borderRadius: "50px", fontWeight: "700", fontSize: "14px", boxShadow: "0 8px 24px rgba(233,30,140,0.35)" },
  btnSecondary: { display: "inline-block", background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.14)", color: "#fff", padding: "14px 28px", borderRadius: "50px", fontWeight: "600", fontSize: "14px" },

  quickStats: { display: "flex", gap: "0", background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.07)", borderRadius: "14px", marginTop: "36px", overflow: "hidden", maxWidth: "480px" },
  qstat: { flex: 1, padding: "14px 10px", textAlign: "center", borderRight: "1px solid rgba(255,255,255,0.06)" },
  qstatNum: { display: "block", fontFamily: "'Syne',sans-serif", fontSize: "20px", fontWeight: "800", color: "#e91e8c" },
  qstatLabel: { fontSize: "11px", color: "rgba(255,255,255,0.35)", marginTop: "2px", letterSpacing: "0.5px" },

  // CITY
  citySection: { borderBottom: "1px solid rgba(255,255,255,0.06)", padding: "24px" },
  cityInner: { maxWidth: "900px", margin: "0 auto" },
  cityLabel: { fontSize: "12px", color: "rgba(255,255,255,0.35)", fontWeight: "600", letterSpacing: "1px", textTransform: "uppercase", marginBottom: "12px" },
  cityRow: { display: "flex", flexWrap: "wrap", gap: "8px", marginBottom: "12px" },
  cityBtn: { padding: "8px 18px", borderRadius: "25px", background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)", color: "rgba(255,255,255,0.6)", fontSize: "13px", fontWeight: "500", display: "flex", alignItems: "center", gap: "6px", transition: "all 0.2s" },
  cityBtnActive: { background: "rgba(233,30,140,0.12)", border: "1px solid rgba(233,30,140,0.4)", color: "#fff", fontWeight: "700" },
  cityCheck: { color: "#e91e8c", fontSize: "12px" },
  cityResult: { fontSize: "13px", color: "rgba(255,255,255,0.35)" },

  // SECTIONS
  section: { padding: "80px 24px" },
  sectionHead: { textAlign: "center", marginBottom: "50px", maxWidth: "600px", margin: "0 auto 50px" },
  sLabel: { display: "inline-block", background: "rgba(233,30,140,0.1)", border: "1px solid rgba(233,30,140,0.25)", color: "#e91e8c", padding: "5px 16px", borderRadius: "20px", fontSize: "11px", fontWeight: "700", letterSpacing: "2px", textTransform: "uppercase", marginBottom: "14px" },
  sTitle: { fontFamily: "'Syne',sans-serif", fontSize: "clamp(24px,4vw,38px)", fontWeight: "800", marginBottom: "12px", color: "#fff" },
  sSub: { fontSize: "15px", color: "rgba(255,255,255,0.4)", lineHeight: "1.75" },

  // CATEGORIES
  catGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(160px,1fr))", gap: "14px", maxWidth: "900px", margin: "0 auto" },
  catCard: { background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.07)", borderRadius: "16px", padding: "22px 18px", display: "flex", flexDirection: "column", gap: "6px" },
  catIcon: { width: "48px", height: "48px", borderRadius: "12px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "22px", marginBottom: "6px" },
  catLabel: { fontSize: "14px", fontWeight: "700", color: "#fff" },
  catCount: { fontSize: "12px", fontWeight: "600" },
  catArrow: { fontSize: "16px", marginTop: "4px" },

  // SEO BLOCK
  seoBlock: { background: "rgba(255,255,255,0.015)", borderTop: "1px solid rgba(255,255,255,0.05)", borderBottom: "1px solid rgba(255,255,255,0.05)", padding: "60px 24px" },
  seoInner: { maxWidth: "900px", margin: "0 auto" },
  seoTitle: { fontFamily: "'Syne',sans-serif", fontSize: "clamp(20px,3vw,28px)", fontWeight: "800", marginBottom: "28px", color: "#fff" },
  seoCols: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "40px" },
  seoH3: { fontSize: "16px", fontWeight: "700", color: "#e91e8c", marginBottom: "10px" },
  seoPara: { fontSize: "14px", color: "rgba(255,255,255,0.55)", lineHeight: "1.85" },

  // WHY
  whyGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(260px,1fr))", gap: "16px", maxWidth: "1000px", margin: "0 auto" },
  whyCard: { background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.07)", borderRadius: "16px", padding: "26px" },
  whyIcon: { width: "50px", height: "50px", borderRadius: "13px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "22px", marginBottom: "14px" },
  whyTitle: { fontSize: "15px", fontWeight: "700", color: "#fff", marginBottom: "8px" },
  whyDesc: { fontSize: "13px", color: "rgba(255,255,255,0.5)", lineHeight: "1.75" },

  // CTA
  cta: { position: "relative", overflow: "hidden", padding: "90px 24px", borderTop: "1px solid rgba(255,255,255,0.06)", background: "linear-gradient(135deg,rgba(233,30,140,0.07),rgba(124,58,237,0.07))" },
  ctaGlow: { position: "absolute", top: "50%", left: "50%", transform: "translate(-50%,-50%)", width: "500px", height: "300px", background: "radial-gradient(ellipse,rgba(233,30,140,0.18),transparent 70%)", pointerEvents: "none" },
  ctaTitle: { fontFamily: "'Syne',sans-serif", fontSize: "clamp(24px,4vw,40px)", fontWeight: "800", marginBottom: "14px" },
  ctaSub: { fontSize: "16px", color: "rgba(255,255,255,0.45)", marginBottom: "32px", lineHeight: "1.8" },
};